import { useState, useEffect, useRef } from "react";
import "./captcha.scss";
import { generateCaptcha } from "@shared/utility/generate-captcha";
import { FaSyncAlt } from "react-icons/fa";

export interface CaptchaProps {
  onRefresh: (captcha: string) => void;
}

export function Captcha({ onRefresh }: CaptchaProps) {
  const [captcha, setCaptcha] = useState<string>(generateCaptcha(4));
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    drawCaptcha();
    onRefresh(captcha);
  }, [captcha, onRefresh]);

  const drawCaptcha = () => {
    if (canvasRef.current) {
      const ctx = canvasRef.current.getContext("2d");
      if (ctx) {
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        ctx.font = "bold 24px Arial";
        ctx.fillStyle = "black";
        ctx.fillText(captcha, 10, 30);
      }
    }
  };

  return (
    <div id="Captcha" className="captcha">
      <canvas
        ref={canvasRef}
        width="120"
        height="40"
        className="captcha-image"
      />
      <button
        className="refresh-button"
        onClick={() => setCaptcha(generateCaptcha(4))}
        aria-label="Refresh Captcha"
      >
        <FaSyncAlt />
      </button>
    </div>
  );
}

export default Captcha;
